export const FETCH_NOTIFICATION_LIST = 'FETCH_NOTIFICATION_LIST';
export const FETCH_NOTIFICATION_COUNT = 'FETCH_NOTIFICATION_COUNT';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const CLEAR_NOTIFICATION_ARRAY = 'CLEAR_NOTIFICATION_ARRAY';
export const UPDATE_LIST = 'UPDATE_LIST';
